import { render, staticRenderFns } from "./AppWorkAnalyzerTillageTable.vue?vue&type=template&id=4c96b169&scoped=true&"
import script from "./AppWorkAnalyzerTillageTable.vue?vue&type=script&lang=js&"
export * from "./AppWorkAnalyzerTillageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c96b169",
  null
  
)

export default component.exports